import React from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import Spinner from "components/button/Spinner";

type PlaydateInviteLoadingViewProps = {
    onBack: () => void;
    baseZIndex?: number;
};

const PlaydateInviteLoadingView: React.FC<PlaydateInviteLoadingViewProps> = ({
    onBack,
    baseZIndex,
}) => {
    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Playdate Invite Details"
            infoText="Loading details..."
            topIcon="happy"
            useSectionDivider={true}
        >
            <div className={styles.spinnerContainer}>
                <Spinner />
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteLoadingView;
